import { View } from "./Catalog.view";

export const Container = () => {
  return <View />;
};
